import styled from 'styled-components';

import {
  colorGrey50,
  colorGrey100,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
} from '@/styleUtils';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  width: 100%;
  margin: 0 auto;
  align-items: center;
`;
export const MainInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
  border: 1px solid ${colorGrey100};
  border-radius: 8px;
  margin-top: 24px;
  padding: 32px 16px;
  height: max-content;
  width: 100%;
`;
export const ContactsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: ${colorGrey50};
  padding: 24px 16px;
  margin-top: 32px;
  max-width: 480px;
  width: 100%;
`;
export const ContactsButton = styled.button`
  display: flex;
  margin: 16px auto 0;
  gap: 4px;
  width: max-content;
  align-items: center;
  height: 48px;
  padding: 12px 16px;
  font: 700 14px / 24px ${fontFamilySecondary};
  border-radius: 4px;
  border: 2px solid ${colorGrey100};
  background: ${colorWhite};
`;
export const Title = styled.h1`
  text-align: center;
  font: 700 18px / 24px ${fontFamilySecondary};
  margin-bottom: 4px;
`;
export const Text = styled.p`
  text-align: center;
  font: 400 14px / 24px ${fontFamilyPrimary};
  margin: 0;
`;
export const StyledImage = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
`;
